import {IRuleset} from "../../../../index";
import rulesetHtml from './ruleset.html?raw';

export const template = rulesetHtml

export class viewModel {
    private readonly data: IRuleset

    constructor(params: {data: IRuleset}) {
        this.data = params.data
    }
}